module.exports = __webpack_public_path__ + "img/example_1.ae4053cb.jpg";